export default __webpack_public_path__ + "static/media/logomarca.c994b3aa.png";